import {DialogBox, DialogBoxBody, DialogBoxProps} from "common/DialogBox"
import {
    GridTableColumn,
    GridTableHeaderWrapper,
    GridTableListItemWrapper
} from "pages/admin/common/common-style-component"
import {useFindAllRealDevice} from "hooks/queries/real-device.query"
import {useState} from "react"

interface DeviceSearchWindowProps extends DialogBoxProps {
    onSelect: (eui: string) => void
}

export const DeviceSearchWindow = ({show, close, title, onSelect}: DeviceSearchWindowProps) => {
    const [keyword, setKeyword] = useState<string | undefined>()
    const {data: response} = useFindAllRealDevice()
    const list = response?.filter(dev => {
        console.log("cll", keyword)
        if (keyword) {
            return dev.communicationDevice.eui.includes(keyword) || dev.name.includes(keyword)
        }
        return true
    }) || []
    return (
        <DialogBox show={show} close={close} title={title}>
            <DialogBoxBody>
                <div className="level is-right">
                    <div className="level-left"/>
                    <div className="level-right">
                        <input type="text" className="input" placeholder="이름 또는 EUI를 검색하세요"
                               defaultValue={keyword}
                               onChange={(e) => setKeyword(e.target.value)}
                        />
                    </div>
                </div>
                <div style={{maxHeight: 600, overflowY: "auto"}}>
                    <GridTableHeaderWrapper gridTemplateColumns="20% 25% auto 15%">
                        <GridTableColumn>이름</GridTableColumn>
                        <GridTableColumn>EUI</GridTableColumn>
                        <GridTableColumn>주소</GridTableColumn>
                        <GridTableColumn>선택</GridTableColumn>
                    </GridTableHeaderWrapper>
                    {list.map(dev => {
                        const address = dev.address.address + dev.address.subAddress
                        const eui = dev.communicationDevice.eui
                        return (
                            <GridTableListItemWrapper key={dev.id} gridTemplateColumns="20% 25% auto 15%">
                                <GridTableColumn>{dev.name}</GridTableColumn>
                                <GridTableColumn>{eui}</GridTableColumn>
                                <GridTableColumn>{address}</GridTableColumn>
                                <GridTableColumn>
                                    <button className="button is-link is-small mt-3" onClick={() => {
                                        onSelect(eui)
                                        close()
                                    }}>선택
                                    </button>
                                </GridTableColumn>
                            </GridTableListItemWrapper>
                        )
                    })}
                </div>
            </DialogBoxBody>
        </DialogBox>
    )
}